import { render, staticRenderFns } from "./retired.vue?vue&type=template&id=12f3e25f&scoped=true"
import script from "./retired.vue?vue&type=script&lang=js"
export * from "./retired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3e25f",
  null
  
)

export default component.exports